import React from "react";
import {css, SerializedStyles, Theme} from "@emotion/react";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {calculateRemSize} from "@pg-design/helpers-css";

import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";

interface IProps {
    vendorId: number;
    offerId: number;
    propertyId: number;
    propertyLink: string;
    applicationSource: number;
    applicationSourceSection: number;
    applicationButtonText?: string;
    moreInfoButtonText?: string;
    clickEvent?: () => void;
    hideApplicationButton?: boolean;
    className?: string;
    buttonSize?: IButtonSizePrimary;
    buttonStyle?: SerializedStyles;
}

export const QWActionButtons = (props: IProps) => {
    const {
        vendorId,
        offerId,
        propertyId,
        propertyLink,
        applicationSource,
        applicationSourceSection,
        applicationButtonText,
        moreInfoButtonText,
        clickEvent,
        hideApplicationButton = false
    } = props;

    const target = useResponsiveLinkTarget();

    const handleDetailsButtonClick = () => clickEvent?.();

    return (
        <div css={buttonsHolder} className={props.className}>
            {!hideApplicationButton && (
                <ApplicationModalButton
                    source={applicationSource}
                    sourceSection={applicationSourceSection}
                    vendorId={vendorId}
                    offerId={offerId}
                    propertyId={propertyId}
                    render={({openModal}) => (
                        <Button variant="filled_primary" onClick={openModal} size={props.buttonSize || "big"} css={props.buttonStyle}>
                            {applicationButtonText ?? "Zapytaj o ofertę"}
                        </Button>
                    )}
                />
            )}

            <Button
                as="a"
                href={propertyLink}
                onClick={handleDetailsButtonClick}
                target={target}
                variant="none_secondary"
                size={props.buttonSize}
                css={props.buttonStyle}
            >
                {moreInfoButtonText ?? "Zobacz szczegóły"}
            </Button>
        </div>
    );
};

const buttonsHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    padding-top: 3.6rem;
    gap: ${calculateRemSize(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        padding-top: 2.4rem;
        flex-direction: row;
        align-items: center;
    }
`;
import React from "react";
import {css, SerializedStyles, Theme} from "@emotion/react";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {calculateRemSize} from "@pg-design/helpers-css";

import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";

interface IProps {
    vendorId: number;
    offerId: number;
    propertyId: number;
    propertyLink: string;
    applicationSource: number;
    applicationSourceSection: number;
    applicationButtonText?: string;
    moreInfoButtonText?: string;
    clickEvent?: () => void;
    hideApplicationButton?: boolean;
    className?: string;
    buttonSize?: IButtonSizePrimary;
    buttonStyle?: SerializedStyles;
}

export const QWActionButtons = (props: IProps) => {
    const {
        vendorId,
        offerId,
        propertyId,
        propertyLink,
        applicationSource,
        applicationSourceSection,
        applicationButtonText,
        moreInfoButtonText,
        clickEvent,
        hideApplicationButton = false
    } = props;

    const target = useResponsiveLinkTarget();

    const handleDetailsButtonClick = () => clickEvent?.();

    return (
        <div css={buttonsHolder} className={props.className}>
            {!hideApplicationButton && (
                <ApplicationModalButton
                    source={applicationSource}
                    sourceSection={applicationSourceSection}
                    vendorId={vendorId}
                    offerId={offerId}
                    propertyId={propertyId}
                    render={({openModal}) => (
                        <Button variant="filled_primary" onClick={openModal} size={props.buttonSize || "big"} css={props.buttonStyle}>
                            {applicationButtonText ?? "Zapytaj o ofertę"}
                        </Button>
                    )}
                />
            )}

            <Button
                as="a"
                href={propertyLink}
                onClick={handleDetailsButtonClick}
                target={target}
                variant="none_secondary"
                size={props.buttonSize}
                css={props.buttonStyle}
            >
                {moreInfoButtonText ?? "Zobacz szczegóły"}
            </Button>
        </div>
    );
};

const buttonsHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    padding-top: 3.6rem;
    gap: ${calculateRemSize(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        padding-top: 2.4rem;
        flex-direction: row;
        align-items: center;
    }
`;
